;(() => {
  function init() {
    window.__shgProductInits.forEach(productInit => {
      const subscription = window.__GLOBLE_PRODUCT_VARIANT_ID_MAP[productInit.productVariantId]

      if (productInit.productVariantId && subscription) {
        productInit.productVariantId = subscription.id
        const variantKey = productInit.uuid
        const form = document.querySelector(`#${variantKey} form`)
        let html = `<input type='hidden' name='properties[shipping_interval_unit_type]' id='rc_shipping_interval_unit_type' value='${subscription.interval_unit_type}'>`
        html += `<input type='hidden' name='properties[shipping_interval_frequency]' value='${subscription.frequency}'>`
        html += `<input type='hidden' name='id' value='${subscription.id}'>`
        html += `<input type='radio' id='rc_purchase_type_autodeliver' name='purchase_type' value='autodeliver' checked='' style='display: none;' class='rc_radio rc_radio__autodeliver'>`

        form.innerHTML = form.innerHTML + html
      }
    })

    for (const productKey in window.__shgProducts) {
      const product = window.__shgProducts[productKey]
      if (
        product.initialVariant &&
        product.initialVariant.id &&
        window.__GLOBLE_PRODUCT_VARIANT_ID_MAP[product.initialVariant.id]
      ) {
        product.initialVariant.id = window.__GLOBLE_PRODUCT_VARIANT_ID_MAP[product.initialVariant.id].id
      }
      product.variants.forEach(variant => {
        if (variant.id && window.__GLOBLE_PRODUCT_VARIANT_ID_MAP[variant.id]) {
          variant.id = window.__GLOBLE_PRODUCT_VARIANT_ID_MAP[variant.id].id
        }
      })
    }
  }

  function changeAddToCartButtonEvent() {
    const forms = document.querySelectorAll('[action="/cart/add.js"]')

    forms.forEach(form => {
      form.setAttribute('data-product-actions', '')
      form.setAttribute('action', '')

      // --- start: remove a-tag default behavior (use button shell) ---
      const elementA = form.querySelector('a')
      const elementAClone = elementA.cloneNode(true)
      elementAClone.style.pointerEvents = 'none'
      const elementParent = elementA.parentNode
      const elementShell = document.createElement('button')

      elementShell.style.display = 'inline-block'
      elementShell.style.cursor = 'pointer'
      elementShell.style.padding = '0'
      elementShell.style.border = '0'

      elementShell.appendChild(elementAClone)
      elementParent.replaceChild(elementShell, elementA)
      // --- end ---

      function buttonClickFn(e) {
        const inputList = form.querySelectorAll('input')
        const formData = []

        for (const item of inputList) {
          formData.push(`${item.name}=${item.value}`)
        }

        // Then we add the product in Ajax
        document.dispatchEvent(new CustomEvent('theme:loading:start'))

        fetch(`${window.routes.cartAddUrl}.js`, {
          body: formData.join('&'),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            // This is needed as currently there is a bug in Shopify that assumes this header
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
          .then(response => {
            if (response.ok) {
              // Open mini-cart
              if (window.theme.cartType === 'drawer') {
                document.documentElement.dispatchEvent(
                  new CustomEvent('cart:open', {
                    bubbles: true,
                  })
                )
              }

              // Refresh min-cart
              if (window.theme.cartType !== 'page') {
                document.documentElement.dispatchEvent(
                  new CustomEvent('cart:refresh', {
                    bubbles: true,
                  })
                )
              }

              // When using a cart type of page, we just simply redirect to the cart page
              if (window.theme.cartType === 'page') {
                location.href = '/cart'
              }
            }
          })
          .finally(() => {
            document.dispatchEvent(new CustomEvent('theme:loading:end'))
          })

        e.preventDefault()
        e.stopPropagation()
      }

      elementShell.addEventListener('click', buttonClickFn)
    })
  }

  init()
  changeAddToCartButtonEvent()
})()
